import React from 'react';
import { defineMessages, InjectedIntl, injectIntl } from 'react-intl';
import Button from '@fenderdigital/ui/Button';
import Link from '../../components/Link';
import MaxWidthLayout from '../../components/MaxWidthLayout';
import Chrome from '../../components/Chrome';
import { getFlag } from '../../lib/feature-flags';

interface NotFoundPropType {
  title: string;
  intl: InjectedIntl;
  staticContext: {
    status: number;
    notFound: boolean;
  };
}

const messages = defineMessages({
  notFoundGoToHome: {
    id: 'not-found.go-to-home',
    defaultMessage: 'Take me home',
  },
  notFoundDescription: {
    id: 'not-found.description',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Sorry, that link may not be valid. You can check out the feed for some of the recommended stuff below.',
  },
});

function NotFound({
  intl,
  title = "We still haven't found what you're looking for...",
  staticContext,
}: NotFoundPropType): JSX.Element {
  const { formatMessage }: InjectedIntl = intl;
  const isPlayAuthRedirectEnabled = getFlag('isPlayAuthRedirectEnabled');
  if (staticContext) {
    staticContext.status = 404;
    staticContext.notFound = true;
  }
  return (
    <>
      {isPlayAuthRedirectEnabled ? (
        <Chrome>
          <MaxWidthLayout>
            <div className="pb4">
              <h1 className="b mb3 mt3">{title}</h1>
              <p className="mb3 f6">{formatMessage(messages.notFoundDescription)}</p>
              <Button as={Link} to="/">
                {formatMessage(messages.notFoundGoToHome)}
              </Button>
            </div>
          </MaxWidthLayout>
        </Chrome>
      ) : (
        <MaxWidthLayout>
          <div className="pb4">
            <h1 className="b mb3 mt3">{title}</h1>
            <p className="mb3 f6">{formatMessage(messages.notFoundDescription)}</p>
            <Button as={Link} to="/">
              {formatMessage(messages.notFoundGoToHome)}
            </Button>
          </div>
        </MaxWidthLayout>
      )}
    </>
  );
}

export default injectIntl(NotFound);
